// Tax ID types organized by country - based on Stripe's official account tax IDs documentation
// Note: Many EU countries use 'eu_vat' with country-specific prefixes in the value (e.g., DE123456789)
export const TAX_ID_TYPES = [
    // European Union Countries (using eu_vat)
    { id: "at_vat", country: "Austria", code: "eu_vat", label: "AT VAT", prefix: "AT" },
    { id: "be_vat", country: "Belgium", code: "eu_vat", label: "BE VAT", prefix: "BE" },
    { id: "bg_vat", country: "Bulgaria", code: "eu_vat", label: "BG VAT", prefix: "BG" },
    { id: "hr_vat", country: "Croatia", code: "eu_vat", label: "HR VAT", prefix: "HR" },
    { id: "cy_vat", country: "Cyprus", code: "eu_vat", label: "CY VAT", prefix: "CY" },
    { id: "cz_vat", country: "Czechia", code: "eu_vat", label: "CZ VAT", prefix: "CZ" },
    { id: "dk_vat", country: "Denmark", code: "eu_vat", label: "DK VAT", prefix: "DK" },
    { id: "ee_vat", country: "Estonia", code: "eu_vat", label: "EE VAT", prefix: "EE" },
    { id: "fi_vat", country: "Finland", code: "eu_vat", label: "FI VAT", prefix: "FI" },
    { id: "fr_vat", country: "France", code: "eu_vat", label: "FR VAT", prefix: "FR" },
    { id: "de_vat", country: "Germany", code: "eu_vat", label: "DE VAT", prefix: "DE" },
    { id: "el_vat", country: "Greece", code: "eu_vat", label: "EL VAT", prefix: "EL" }, // Greece uses EL prefix
    { id: "hu_vat", country: "Hungary", code: "eu_vat", label: "HU VAT", prefix: "HU" },
    { id: "ie_vat", country: "Ireland", code: "eu_vat", label: "IE VAT", prefix: "IE" },
    { id: "it_vat", country: "Italy", code: "eu_vat", label: "IT VAT", prefix: "IT" },
    { id: "lv_vat", country: "Latvia", code: "eu_vat", label: "LV VAT", prefix: "LV" },
    { id: "lt_vat", country: "Lithuania", code: "eu_vat", label: "LT VAT", prefix: "LT" },
    { id: "lu_vat", country: "Luxembourg", code: "eu_vat", label: "LU VAT", prefix: "LU" },
    { id: "mt_vat", country: "Malta", code: "eu_vat", label: "MT VAT", prefix: "MT" },
    { id: "nl_vat", country: "Netherlands", code: "eu_vat", label: "NL VAT", prefix: "NL" },
    { id: "pl_vat", country: "Poland", code: "eu_vat", label: "PL VAT", prefix: "PL" },
    { id: "pt_vat", country: "Portugal", code: "eu_vat", label: "PT VAT", prefix: "PT" },
    { id: "ro_vat", country: "Romania", code: "eu_vat", label: "RO VAT", prefix: "RO" },
    { id: "sk_vat", country: "Slovakia", code: "eu_vat", label: "SK VAT", prefix: "SK" },
    { id: "si_vat", country: "Slovenia", code: "eu_vat", label: "SI VAT", prefix: "SI" },
    { id: "es_vat", country: "Spain", code: "eu_vat", label: "ES VAT", prefix: "ES" },
    { id: "es_cif", country: "Spain", code: "es_cif", label: "ES CIF" },
    { id: "se_vat", country: "Sweden", code: "eu_vat", label: "SE VAT", prefix: "SE" },

    // Other European Countries
    { id: "is_vat", country: "Iceland", code: "is_vat", label: "IS VAT" },
    { id: "li_vat", country: "Liechtenstein", code: "li_vat", label: "LI VAT" },
    { id: "me_pib", country: "Montenegro", code: "me_pib", label: "ME PIB" },
    { id: "mk_vat", country: "North Macedonia", code: "mk_vat", label: "MK VAT" },
    { id: "no_vat", country: "Norway", code: "no_vat", label: "NO VAT" },
    { id: "rs_pib", country: "Serbia", code: "rs_pib", label: "RS PIB" },
    { id: "ch_vat", country: "Switzerland", code: "ch_vat", label: "CH VAT" },
    { id: "gb_vat", country: "United Kingdom", code: "gb_vat", label: "GB VAT" },
    { id: "xi_vat", country: "United Kingdom (Northern Ireland)", code: "eu_vat", label: "XI VAT", prefix: "XI" },
] as const;

export type TaxIdType = (typeof TAX_ID_TYPES)[number];

// Map of tax ID types by their unique ID for quick lookup
export const TAX_ID_TYPES_BY_ID = TAX_ID_TYPES.reduce(
    (acc, item) => {
        acc[item.id] = item;
        return acc;
    },
    {} as Record<string, TaxIdType>,
);
